import React, { useEffect, useState } from "react";
import { Box, Button, Link, TextField } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { useAccount, useBalance, useToken } from "wagmi";
import {
  POTION_DAO_CHEF_ADDRESS,
  POTION_DAO_ZAP_ADDRESS,
  PTN_TOKEN_ADDRESS,
  WETH_TOKEN_ADDRESS,
  BNB_ORACLE,
  SHLD_BNB_LP,
  WETHX_TOKEN_ADDRESS,
  BNBX_BNB_LP,
  BNB_GUARD_ORACLE,
  GUARD,
  ANDY,
  ANDY_BNB_ORACLE,
} from "../Config";
import useCustomContractRead from "../Hooks/useCustomContractRead";
import POTION_DAO_CHEF_ABI from "../Config/POTION_DAO_CHEF_ABI.json";
import TOKEN_ABI from "../Config/TOKEN_ABI.json";
import BNBORACLEABI from "../Config/BNBORACLE.json";

import IUniswapv2Pair from "../Config/IUniswapv2Pair.json";
import IUniswapOracle from "../Config/IUniswapOracle.json";
import IUniswapOracleV3 from "../Config/IUniswapOracleV3.json";

import POTION_DAO_ZAP_ABI from "../Config/POTION_DAO_ZAP_ABI.json";
// import IUniswapv2Pair from "../Config/IUniswapv2Pair.json";
import ApproveButton from "./common/ApproveButton";
import useCustomContractWrite from "../Hooks/useCustomContractWrite";
import convertEtherToWei from "../Utils/convertEtherToWei";
import Loader from "./Loader/Loader";
import convertWeiToEther from "../Utils/convertWeiToEther";
import PropTypes from "prop-types";
import zapBtn from "../../src/Components/Image/zapBtn.svg";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ZapModal } from "./Pages/Farms/ZapModal";
import useCheckAllowance from "../Hooks/useCheckAllowance";
import style from "../Components/Pages/Farms/farm.module.css";
import { BigNumber, ethers } from "ethers";
import { Style } from "@mui/icons-material";
import { formatNumber } from "./common/FormateNum";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      sx={{
        m: 0,
        p: 2,
        background: "red",
        color: "#CCB483",
        borderBottom: "1px solid #CCB483",
      }}
      {...other}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#CCB483",
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export const FarmAccordion = (props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const { address, isConnected } = useAccount();
  const [isAproveERC20, setIsApprovedERC20] = useState(false);
  const [inputDepositValue, setInputDepositValue] = useState("");
  const [inputWithdrawValue, setInputWithdrawValue] = useState("");
  const [inputWithdrawFeeValue, setInputWithdrawFeeValue] = useState("");

  const { openConnectModal } = useConnectModal();

  const handleInputDepositChange = (event) => {
    const { value } = event.target;
    const isStack = /^[0-9]*(\.[0-9]{0,18})?$/.test(value);
    if (isStack) {
      setInputDepositValue(value);
    }
  };

  const setMax = (value) => {
    const isStack = /^[0-9]*(\.[0-9]{0,9})?$/.test(value);
    if (isStack) {
      setInputDepositValue(value);
    }
  };

  const handleInputWithdrawChange = (event) => {
    const { value } = event.target;
    const isStack = /^[0-9]*(\.[0-9]{0,18})?$/.test(value);
    if (isStack) {
      setInputWithdrawValue(value);
      handleFee(value);
    }
  };
  const { data: lpToken } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    FuncName: "lpToken",
    Args: [props?.poolIndex],
    onSuccess: (data) => {},
  });

  const { data: zapsDetail } = useCustomContractRead({
    Adrress: POTION_DAO_ZAP_ADDRESS,
    Abi: POTION_DAO_ZAP_ABI,
    FuncName: "zaps",
    Args: [props?.poolIndex],
    onSuccess: (data) => {},
  });
  // console.log("zapsDetail", zapsDetail);

  const { data: token0Info } = useToken({
    address: zapsDetail?.[1],
    enabled: zapsDetail?.[1] !== undefined,
  });
  const { data: token1Info } = useToken({
    address: zapsDetail?.[2],
    enabled: zapsDetail?.[2] !== undefined,
  });

  const { data: lpBalance } = useBalance({
    address: address,
    token: lpToken,
    watch: true,
    enabled: lpToken !== undefined && address !== undefined,
  });

  const handlePercentageClick = (percentage) => {
    if (lpBalance) {
      // const balance = parseFloat(lpBalance?.formatted); // Assuming `mntBalance.formatted` is in a readable format
      // setInputDepositValue((balance * (percentage / 100)).toFixed(18));
      const balance = ethers.utils.parseUnits(
        lpBalance.formatted,
        lpBalance.decimals
      ); // Convert to BigNumber
      const percentageValue = balance.mul(percentage).div(100); // Calculate percentage
      const formattedValue = ethers.utils.formatUnits(
        percentageValue,
        lpBalance.decimals
      ); // Format back to string
      setInputDepositValue(formattedValue); // Update state with the precise value
    }
  };
  //console.log("InputDeposit", parseFloat(lpBalance?.formatted), inputDepositValue);

  const { data: lpFarmBalance } = useBalance({
    address: POTION_DAO_CHEF_ADDRESS,
    token: lpToken,
    watch: true,
    enabled: lpToken !== undefined && POTION_DAO_CHEF_ADDRESS !== undefined,
  });

  const { data: checkAllowance } = useCheckAllowance({
    tokenAddress: lpToken,
    spenderAddress: POTION_DAO_CHEF_ADDRESS,
    isLpToken: true,
  });

  // const {data:checkAllowance} = useCustomContractRead({
  //   Adrress: lpToken,
  //   Abi: TOKEN_ABI,
  //   FuncName: "allowance",
  //   Args: [address, POTION_DAO_CHEF_ADDRESS],
  //   isEnabled: (
  //     address !== undefined
  //     )
  // });

  // console.log("isAproveERC20", props?.poolIndex, isAproveERC20);

  useEffect(() => {
    if (address) {
      const price = parseFloat?.(
        inputDepositValue === "" ? "1" : inputDepositValue
      );
      const allowance = parseFloat?.(convertWeiToEther?.(checkAllowance));
      if (allowance >= price) {
        setIsApprovedERC20(true);
      } else {
        setIsApprovedERC20(false);
      }
    }
  }, [checkAllowance, address, inputDepositValue]);

  const {
    executeWrite: depositContractWrite,
    isLoading: isLoadingDeposit,
    isSuccess: isSuccessDeposit,
    isError: isErrorDeposit,
    error: errorDeposit,
    txHash: depositWaitForTransaction,
  } = useCustomContractWrite({
    address: POTION_DAO_CHEF_ADDRESS,
    abi: POTION_DAO_CHEF_ABI,
    functionName: "deposit",
    args: [props?.poolIndex, convertEtherToWei(inputDepositValue), address],
    isEnabled: convertEtherToWei(inputDepositValue) > 0,
  });

  const { data: userInfo } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    FuncName: "userInfo",
    Args: [props?.poolIndex, address],
    isEnabled: address !== undefined,
    onSuccess: (data) => {
      //console.log("user", props?.poolIndex);
      //console.log("user", address);
      //console.log("user", data);
    },
  });

  const handlePercentageClickWithdraw = (percentage) => {
    if (userInfo?.[0]) {
      const balance = ethers.utils.parseUnits(userInfo?.[0].toString(), 0);
      const value = balance.mul(percentage).div(100);
      const formattedValue = ethers.utils.formatUnits(value, 18);
      setInputWithdrawValue(formattedValue);
      handleFee(formattedValue);
    }
  };

  const { data: pendingReward } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    FuncName: "pendingReward",
    Args: [props?.poolIndex, address],
    onSuccess: (data) => {},
    isEnabled: address !== undefined,
  });

  const { data: rewardPerSecond } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    FuncName: "rewardPerSecond",
    onSuccess: (data) => {},
  });

  const { data: _totalAllocPOint } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    FuncName: "totalAllocPoint",
    onSuccess: (data) => {
      //console.log("_totalAllocPOint", data._totalAllocPOint);
    },
  });

  const { data: _poolInfo } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    Args: [props?.poolIndex],
    FuncName: "poolInfo",
    onSuccess: (data) => {},
  });

  const handleFee = (value) => {
    const fee = parseFloat(_poolInfo?.[4]);
    //console.log("FEEE", fee);

    if (fee && value) {
      const balance = parseFloat(value); // Assuming `mntBalance.formatted` is in a readable format
      //console.log("balancefee", balance, fee);
      setInputWithdrawFeeValue((balance * fee) / 10000)?.toFixed(18);
    } else {
      //console.log("balancefee", "bgtg", value);
      setInputWithdrawFeeValue(0);
    }
  };

  // useEffect(() => {
  //   return () => {
  //     handleFee();
  //   };
  // }, [_poolInfo, inputWithdrawValue]);

  const {
    executeWrite: harvestContractWrite,
    isLoading: isLoadingHarvest,
    isSuccess: isSuccessHarvest,
    isError: isErrorHarvest,
    error: errorHarvest,
    txHash: harvestWaitForTransaction,
  } = useCustomContractWrite({
    address: POTION_DAO_CHEF_ADDRESS,
    abi: POTION_DAO_CHEF_ABI,
    functionName: "harvest",
    args: [props?.poolIndex, address],
    isEnabled:
      parseFloat?.(pendingReward).toFixed(2) > 0 && address !== undefined,
  });

  const {
    executeWrite: withdrawContractWrite,
    isLoading: isLoadingWithdraw,
    isSuccess: isSuccessWithdraw,
    isError: isErrorWithdraw,
    error: errorWithdraw,
    txHash: withdrawWaitForTransaction,
  } = useCustomContractWrite({
    address: POTION_DAO_CHEF_ADDRESS,
    abi: POTION_DAO_CHEF_ABI,
    functionName: "withdraw",
    args: [
      props?.poolIndex,
      convertEtherToWei?.(inputWithdrawValue === "" ? "0" : inputWithdrawValue),
      address,
    ],
    isEnabled:
      parseFloat?.(userInfo?.[0]) >=
        parseFloat?.(inputWithdrawValue === "" ? "0" : inputWithdrawValue) &&
      address !== undefined,
  });

  // const {
  //   _useContractWrite: emergencyWithdrawContractWrite,
  //   _useWaitForTransaction: emergencyWithdrawWaitForTransaction,
  // } = useCustomContractWrite({
  //   Adrress: POTION_DAO_CHEF_ADDRESS,
  //   Abi: POTION_DAO_CHEF_ABI,
  //   FuncName: "emergencyWithdraw",
  //   Args: [props?.poolIndex, address],
  //   isEnabled:
  //     parseFloat?.(userInfo?.[0]).toFixed(2) > 0 && address !== undefined,
  // });

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  let alienPrice = 0;
  const alienxPrice = 545;

  const { data: _alienPrice } = useCustomContractRead({
    Adrress: BNB_ORACLE,
    Abi: BNBORACLEABI,
    FuncName: "latestAnswer",
    // onSuccess:(data)=>{
    //   alienPrice = ethers.utils.formatUnits(data, 8);
    // }
  });

  alienPrice = _alienPrice ? ethers.utils.formatUnits(_alienPrice, 8) : 1;

  const lpRat1 = 2300;
  const lpRate2 = 2300;

  const [potionPrice, setPotionPrice] = useState(0);
  const { data: getAmountOutFoMinati } = useCustomContractRead({
    Adrress: SHLD_BNB_LP,
    Abi: IUniswapv2Pair,
    FuncName: "getReserves",
    isEnabled: SHLD_BNB_LP !== undefined,
    onSuccess: (data) => {
      let _ptn = Number(data[1]);
      let _weth = Number(data[0]) * Number(alienPrice);
      let _price = Number(_weth) / Number(_ptn);
      setPotionPrice(_price);
    },
  });
  // const potionPrice = 0.0006358  ; // $ hard coded value

  useEffect(() => {
    if (getAmountOutFoMinati && alienPrice) {
      let _ptn = Number(getAmountOutFoMinati[1]);
      let _weth = Number(getAmountOutFoMinati[0]) * Number(alienPrice);
      let _price = Number(_weth) / Number(_ptn);
      if (!Number(_price)) {
        setPotionPrice(0);
      } else {
        setPotionPrice(_price);
      }
      // console.log("pricerate", _ptn,_weth,_price.toNumber(), alienPrice);
    }
  }, [getAmountOutFoMinati, alienPrice]);

  const [bnbXPrice, setbnbXPrice] = useState(0);
  const { data: reservesBNBX } = useCustomContractRead({
    Adrress: BNBX_BNB_LP,
    Abi: IUniswapv2Pair,
    FuncName: "getReserves",
    isEnabled: SHLD_BNB_LP !== undefined,
    onSuccess: (data) => {
      let _wethx = Number(data[1]);
      let _weth = Number(data[0]) * Number(alienPrice);
      let _price = Number(_weth) / Number(_wethx);
      setbnbXPrice(_price);
    },
  });

  useEffect(() => {
    if (reservesBNBX && alienPrice) {
       let _wethx = Number(reservesBNBX[1]);
      let _weth = Number(reservesBNBX[0]) * Number(alienPrice);
      let _price = Number(_weth) / Number(_wethx);
      setbnbXPrice(_price);
    }
  }, [reservesBNBX, alienPrice])
  


  const [guardPrice, setguardPrice] = useState(0);
  const { data: spotPrice } = useCustomContractRead({
    Adrress: BNB_GUARD_ORACLE,
    Abi: IUniswapOracle,
    FuncName: "spot",
    isEnabled: alienPrice !== undefined,
    Args: [GUARD, "1000000000000000000"],
    onSuccess: (data) => {
      setguardPrice(convertWeiToEther(spotPrice) * alienPrice);
    },
  });

  const [andyPrice, setandyPrice] = useState(0);
  const { data: spotPriceAndy } = useCustomContractRead({
    Adrress: ANDY_BNB_ORACLE,
    Abi: IUniswapOracleV3,
    FuncName: "quote",
    isEnabled: alienPrice !== undefined,
    Args: [ANDY, "1000000000000000000", WETH_TOKEN_ADDRESS],
    onSuccess: (data) => {
      setandyPrice(convertWeiToEther(spotPriceAndy) * alienPrice);
    },
  });


  // const potionPrice = 0.0006358  ; // $ hard coded value

  useEffect(() => {
    if (spotPrice && alienPrice) {
      setguardPrice(convertWeiToEther(spotPrice) * alienPrice);
      // console.log("pricerate", _ptn,_weth,_price.toNumber(), alienPrice);
    }
  }, [spotPrice, alienPrice]);

   useEffect(() => {
    if (spotPriceAndy && alienPrice) {
      setandyPrice(convertWeiToEther(spotPriceAndy) * alienPrice);
      // console.log("pricerate", _ptn,_weth,_price.toNumber(), alienPrice);
    }
  }, [spotPriceAndy, alienPrice]);


  const { data: lpBalanceChef } = useBalance({
    address: lpToken,
    token: PTN_TOKEN_ADDRESS,
    watch: true,
    enabled: lpToken !== undefined && PTN_TOKEN_ADDRESS !== undefined,
  });

  const { data: lpBalanceChef2 } = useBalance({
    address: lpToken,
    token: WETH_TOKEN_ADDRESS,
    watch: true,
    enabled: lpToken !== undefined && WETH_TOKEN_ADDRESS !== undefined,
  });

  const { data: lpBalanceChef3 } = useBalance({
    address: lpToken,
    token: WETHX_TOKEN_ADDRESS,
    watch: true,
    enabled: lpToken !== undefined && WETHX_TOKEN_ADDRESS !== undefined,
  });

  const { data: lpBalanceChef4 } = useBalance({
    address: lpToken,
    token: GUARD,
    watch: true,
    enabled: lpToken !== undefined && GUARD !== undefined,
  });

    const { data: lpBalanceChef6 } = useBalance({
    address: lpToken,
    token: ANDY,
    watch: true,
    enabled: lpToken !== undefined && ANDY !== undefined,
  });

  // //console.log("lpBalanceChef2", potionPrice, props?.poolIndex , lpBalanceChef2, lpBalanceChef, lpBalanceChef?.value.toString() == '0' ? true : false );

  const [lpPrice, setLpPrice] = useState(0);

  const { data: _lpRate2 } = useCustomContractRead({
    Adrress: lpToken,
    Abi: TOKEN_ABI,
    FuncName: "totalSupply",
    isEnabled: lpToken,
    onSuccess: (data) => {
      // //console.log("lp price tokensupply", convertWeiToEther(data));

      if (lpBalanceChef?.value.toString() !== "0") {
        // //console.log("lp price value", props?.poolIndex  , potionPrice * lpBalanceChef?.formatted * 2);
        // //console.log("lp price",lpBalanceChef?.formatted);
        // //console.log("hello---------------",lpToken, potionPrice,lpBalanceChef?.formatted * 2, data.toString());
        const lpRate2 =
          (potionPrice * lpBalanceChef?.formatted * 2) /
          convertWeiToEther(data);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
        // setPotionPrice(_price);
      } else if (lpBalanceChef2?.value.toString() !== "0") {
        const lpRate2 =
          (alienPrice * lpBalanceChef2?.formatted * 2) /
          convertWeiToEther(data);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
      }
      else if (lpBalanceChef3?.value.toString() !== "0") {
        const lpRate2 =
          (bnbXPrice * lpBalanceChef3?.formatted * 2) /
          convertWeiToEther(_lpRate2);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
      } else if (lpBalanceChef4.value.toString() !== "0") {
        const lpRate2 =
          (guardPrice * lpBalanceChef4?.formatted * 2) /
          convertWeiToEther(_lpRate2);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
      }
      else if (lpBalanceChef6.value.toString() !== "0") {
        const lpRate2 =
          (andyPrice * lpBalanceChef6?.formatted * 2) /
          convertWeiToEther(_lpRate2);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
      }
    
    },
  });

  useEffect(() => {
    if (_lpRate2 && (lpBalanceChef || lpBalanceChef2 || lpBalanceChef3 || lpBalanceChef4)) {
      if (lpBalanceChef?.value.toString() !== "0") {
        // //console.log("lp price value", props?.poolIndex  , potionPrice * lpBalanceChef?.formatted * 2);
        // //console.log("lp price",lpBalanceChef?.formatted);
        // //console.log("hello---------------",lpToken, potionPrice,lpBalanceChef?.formatted * 2, data.toString());
        const lpRate2 =
          (potionPrice * lpBalanceChef?.formatted * 2) /
          convertWeiToEther(_lpRate2);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
        // setPotionPrice(_price);
      } else if (lpBalanceChef2?.value.toString() !== "0") {
        const lpRate2 =
          (alienPrice * lpBalanceChef2?.formatted * 2) /
          convertWeiToEther(_lpRate2);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
      } else if (lpBalanceChef3?.value.toString() !== "0") {
        const lpRate2 =
          (bnbXPrice * lpBalanceChef3?.formatted * 2) /
          convertWeiToEther(_lpRate2);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
      } else if (lpBalanceChef4.value.toString() !== "0") {
        const lpRate2 =
          (guardPrice * lpBalanceChef4?.formatted * 2) /
          convertWeiToEther(_lpRate2);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
      }
      else if (lpBalanceChef6.value.toString() !== "0") {
        const lpRate2 =
          (andyPrice * lpBalanceChef6?.formatted * 2) /
          convertWeiToEther(_lpRate2);
        // //console.log("lp price rate", lpRate2);
        setLpPrice(lpRate2);
      }
    }
  }, [
    _lpRate2,
    lpFarmBalance,
    lpBalanceChef,
    lpBalanceChef2,
    lpBalanceChef3,
    lpBalanceChef4,
    lpBalanceChef6,
    alienPrice,
    andyPrice,
    bnbXPrice,
    guardPrice,
    potionPrice
  ]);

  // console.log(props.poolIndex, lpPrice);
  // console.log(props.poolIndex,lpFarmBalance);

  // //console.log("lp price final",convertWeiToEther?.(_lpRate2));

  // console.log("LpPrice", props?.poolIndex, lpPrice, lpBalanceChef2?.value.toString(), lpToken);

  const getApr = () => {
    // Convert and check rewardRate
    const rewardRate = rewardPerSecond ? convertWeiToEther(rewardPerSecond) : 0;

    // Calculate farmsRewardPerSecond, ensuring alloc points are valid
    const farmsRewardPerSecond =
      _poolInfo?.[0] && _totalAllocPOint
        ? (Number(_poolInfo[2]) / Number(_totalAllocPOint)) * Number(rewardRate)
        : 0;

    // Calculate annualFarmReward, ensuring farmsRewardPerSecond is valid
    const annualFarmReward = farmsRewardPerSecond * 86400 * 365;
    // //console.log("annualFarmReward", annualFarmReward);

    // Calculate annualFarmRewardUSD, ensuring potionPrice is valid
    const annualFarmRewardUSD = potionPrice
      ? annualFarmReward * potionPrice
      : 0;
    // //console.log("annualFarmRewardUSD", annualFarmRewardUSD);

    // Ensure lpFarmBalance and lpPrice are valid for TVL calculation
    const amount = lpFarmBalance?.formatted || 0;
    const totalValueLockedFarmUSD = amount * (lpPrice || 0);
    // //console.log("totalValueLockedFarmUSD", props?.poolIndex, totalValueLockedFarmUSD);

    // Calculate APR, ensuring totalValueLockedFarmUSD is not zero
    const APR = totalValueLockedFarmUSD
      ? parseFloat((annualFarmRewardUSD / totalValueLockedFarmUSD) * 100)
      : 0;

    // //console.log("APR", props?.poolIndex, APR);

    return APR;
  };

  //console.log(props, "pro");
  const accordArr = ["One", "Two", "Three", "Four", "Five"];

  function convertSeconds(seconds) {
    const days = Math.floor(seconds / (24 * 3600)); // 24 hours * 3600 seconds in an hour
    seconds %= 24 * 3600;
    const hours = Math.floor(seconds / 3600); // 3600 seconds in an hour
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60); // 60 seconds in a minute
    seconds %= 60; // remaining seconds

    // return `${days} days, ${hours} hours, ${minutes} minutes, and ${seconds} seconds`;
    return `${days}D:${hours}H:${minutes}M:${seconds}S `;
  }

  const formatTimeLeft = (seconds) => {
    const days = Math.floor(seconds / (24 * 3600));
    seconds %= 24 * 3600;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${days}d ${hours}h ${minutes}m ${secs}s`;
  };

  const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
  const unlockTime = parseFloat(userInfo?.[2]?.toString()); // userInfo[2] is unlockTime
  const targetEpochTime = parseInt(unlockTime);

  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    // Set the initial time left
    setTimeLeft(targetEpochTime - currentTime);

    // Update the time left every second
    const timerInterval = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(timerInterval);
  }, [targetEpochTime, currentTime]);

  // console.log("rewardPerSecond", parseFloat?.(rewardPerSecond) > 0 &&
  // _totalAllocPOint &&
  // _poolInfo
  //   ? formatNumber((
  //       parseFloat?.(
  //         convertWeiToEther?.(rewardPerSecond?.toString())
  //       ) *
  //       86400 *
  //       (Number(_poolInfo?.[2]) /
  //         (Number(_totalAllocPOint) ? Number(_totalAllocPOint) : 1)) *
  //       potionPrice
  //     ).toFixed(2)));

  // if (lpToken?.toLowerCase() === "0x47980273e8B852BEE6dF646aC2897b349dD6f2A8".toLowerCase()) {
  // console.log(lpToken, lpPrice? lpPrice: 0, lpBalanceChef, lpBalanceChef2,lpBalanceChef3, bnbXPrice);
  // }

  return (
    <>
      {/* <Accordian/> */}
      {/* {//console.log("prop Index", props.index)} */}
      <div className={style.accordian + " my-4"}>
        <div
          className={
            style.row1 + " accordion-button d-flex justify-content-between"
          }
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapse${accordArr[props.index]}`}
          aria-expanded={props.index == 0 ? "true" : "false"}
          aria-controls={`collapse${accordArr[props.index]}`}
        >
          <div className="d-flex gap-2 align-items-center flex-grow-1">
            <div className={style.imgdiv + " d-flex gap-sm-2"}>
              <div className="d-flex justify-content-center align-items-center">
                <img
                  src={props?.data?.image}
                  alt="img"
                  width={"100%"}
                  style={{ marginRight: "-3.2px" }}
                />
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <img src={props?.data?.image1} width={"100%"} alt="img" />
              </div>
            </div>
            <div className="bag-60 text-stretch">
              <div className="d-flex gap-2 align-items-center">
                <h1>{props.data.title}</h1>
                {(props?.poolIndex === 0 ||
                  props?.poolIndex === 1 ||
                  props?.poolIndex === 3 ||
                props?.poolIndex === 5) && (
                  <button className={style.zapbtn} onClick={handleClickOpen}>
                    <img src="/icons/zap.svg" alt="" />
                    <span className="ms-1">Zap</span>
                  </button>
                )}
              </div>

              <p>
                {/* {_totalAllocPOint}
                    {_totalAllocPOint && _poolInfo && (parseFloat(_poolInfo?.[0])/(_totalAllocPOint ? parseFloat(_totalAllocPOint).toString : 1))} */}
                {parseFloat?.(rewardPerSecond) > 0 &&
                _totalAllocPOint &&
                _poolInfo
                  ? (
                      (
                        parseFloat?.(
                          convertWeiToEther?.(rewardPerSecond?.toString())
                        ) * 86400
                      ).toFixed(2) *
                      (Number(_poolInfo?.[2]) /
                        (Number(_totalAllocPOint)
                          ? Number(_totalAllocPOint)
                          : 1))
                    ).toFixed(2)
                  : 0}{" "}
                SHiELD per day
              </p>
            </div>
          </div>
          <div className="d-flex gap-xxl-5 gap-xl-4 gap-2 align-items-center">
            <div className="d-none d-lg-block text-center">
              <span>TVL</span>
              <p>
                $
                {formatNumber(
                  parseFloat?.(lpFarmBalance?.formatted * lpPrice).toFixed(2)
                )}
              </p>
            </div>
            <div className="d-none d-lg-block text-center">
              <span>Deposited</span>
              <p>
                {userInfo?.[0]
                  ? formatNumber(
                      parseFloat?.(
                        convertWeiToEther?.(userInfo?.[0]?.toString())
                      ).toFixed(3)
                    )
                  : "0.0"}
              </p>
            </div>
            <div className="d-none d-lg-block text-center">
              <span>Earn</span>
              <p>
                $
                {parseFloat?.(rewardPerSecond) > 0 &&
                _totalAllocPOint &&
                _poolInfo
                  ? formatNumber(
                      (
                        parseFloat?.(
                          convertWeiToEther?.(rewardPerSecond?.toString())
                        ) *
                        86400 *
                        (Number(_poolInfo?.[2]) /
                          (Number(_totalAllocPOint)
                            ? Number(_totalAllocPOint)
                            : 1)) *
                        potionPrice
                      ).toFixed(2)
                    )
                  : 0}{" "}
                per day
              </p>
            </div>
            <div className="d-none d-lg-block text-center">
              <span>APR</span>
              <p>{formatNumber(parseFloat(getApr()).toFixed(2))}%</p>
            </div>
            <div className="d-none d-lg-block text-center">
              <span>Locking Duration</span>
              <p>{convertSeconds(parseInt(Number(_poolInfo?.[3])))}</p>
            </div>
            <button className="d-flex justify-content-center align-items-center">
              <img src="/icons/arrow-down.png" alt="" />
            </button>
          </div>
        </div>
        <div
          id={`collapse${accordArr[props.index]}`}
          className={`accordion-collapse collapse ${
            props.index === 0 ? "show" : ""
          }`}
          data-bs-parent="#accordionExample"
        >
          {/* state code for tab and mini devices */}
          <div
            className={
              style.minidisplay +
              " d-flex flex-wrap  flex-md-nowrap gap-3  d-lg-none  my-4 justify-content-md-between justify-content-center"
            }
          >
            <div className="text-center">
              <span>TVL</span>
              <p>
                $
                {formatNumber(
                  parseFloat?.(lpFarmBalance?.formatted * lpPrice).toFixed(2)
                )}
              </p>
            </div>
            <div className="text-center">
              <span>Deposited</span>
              <p>
                {userInfo?.[0]
                  ? formatNumber(
                      parseFloat?.(
                        convertWeiToEther?.(userInfo?.[0]?.toString())
                      ).toFixed(3)
                    )
                  : "0.0"}
              </p>
            </div>
            <div className="text-center">
              <span>Earn</span>
              <p className="text-nowrap">
                $
                {parseFloat?.(rewardPerSecond) > 0 &&
                _totalAllocPOint &&
                _poolInfo
                  ? formatNumber(
                      (
                        parseFloat?.(
                          convertWeiToEther?.(rewardPerSecond?.toString())
                        ) *
                        86400 *
                        (Number(_poolInfo?.[2]) /
                          (_totalAllocPOint ? Number(_totalAllocPOint) : 1)) *
                        potionPrice
                      ).toFixed(2)
                    )
                  : 0}{" "}
                per day
              </p>
            </div>
            <div className="text-center">
              <span>APR</span>
              <p>{formatNumber(parseFloat(getApr()).toFixed(2))}%</p>
            </div>
            <div className="text-center">
              <span>Locking Duration</span>
              <p className="text-nowrap">
                {convertSeconds(parseInt(Number(_poolInfo?.[3])))}
              </p>
            </div>
          </div>
          {/* end code for tab and mini devices */}

          <div
            className={
              style.box_container +
              " mt-4 accordion-body d-flex flex-wrap flex-lg-nowrap gap-2 justify-content-between"
            }
          >
            <div>
              <div className="d-flex justify-content-between w-100">
                <p>Deposit</p>
                <p>
                  <span className="me-2">Balance</span>
                  {lpBalance?.formatted
                    ? parseFloat?.(lpBalance?.formatted).toFixed(2)
                    : "0.00"}{" "}
                  {props.data?.title} Lp
                </p>
              </div>
              <div className="d-flex flex-column justify-content-between">
                <input
                  type="number"
                  className="text-field"
                  placeholder="0.00"
                  value={Number(inputDepositValue).toFixed(5)}
                  onChange={handleInputDepositChange}
                />
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div className="d-flex align-items-center gap-1">
                    <button
                      className="bg-white"
                      onClick={() => handlePercentageClick(10)}
                    >
                      10%
                    </button>
                    <button
                      className="bg-white"
                      onClick={() => handlePercentageClick(25)}
                    >
                      25%
                    </button>
                    <button
                      className="bg-white"
                      onClick={() => handlePercentageClick(50)}
                    >
                      50%
                    </button>
                    <button
                      className="bg-white"
                      onClick={() => handlePercentageClick(75)}
                    >
                      75%
                    </button>
                  </div>
                  <div>
                    {" "}
                    <button
                      className={`btn1 ${style.max_btn}`}
                      onClick={() => handlePercentageClick(100)}
                    >
                      Max
                    </button>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between gap-3">
                <div
                  className={`${style.info_div} position-relative d-flex justify-content-center align-items-center tooltip-parent`}
                >
                  <img src="/icons/info.svg" alt="" />
                  <p className="info-tooltip position-absolute fw-normal">
                    Deposit LP tokens into the pool. Use percentage buttons for
                    quick allocation.
                  </p>
                </div>
                {isConnected && address ? (
                  !isAproveERC20 ? (
                    <div className="flex-grow-1">
                      <ApproveButton
                        tokenAddress={lpToken}
                        spenderAddress={POTION_DAO_CHEF_ADDRESS}
                        setIsApprovedERC20={setIsApprovedERC20}
                        isLpToken={true}
                        color={"white"}
                      />
                    </div>
                  ) : parseFloat?.(
                      inputDepositValue == "" ? "0" : inputDepositValue
                    ).toFixed(18) > parseFloat?.(lpBalance?.formatted) ? (
                    <button className="btn1 py-3 w-100">
                      Insufficient Fund
                    </button>
                  ) : (
                    <button
                      disabled={
                        parseFloat?.(inputDepositValue) > 0 && !isLoadingDeposit
                          ? false
                          : true
                      }
                      onClick={async () => {
                        try {
                          // //console.log(parseFloat(inputDepositValue).toFixed(2) > 0)
                          // //console.log("amount",convertEtherToWei?.(inputDepositValue === "" ? "0" : parseFloat(inputDepositValue).toFixed(2)));
                          // //console.log("amount",parseInt(convertEtherToWei?.(inputDepositValue === "" ? "0" : parseFloat(inputDepositValue).toFixed(2))));
                          await depositContractWrite();
                          setInputDepositValue(0);
                        } catch (error) {
                          //console.log(error);
                        }
                      }}
                      sx={{
                        gap: "10px !important",
                        "&.Mui-disabled": {
                          cursor: "not-allowed !important",
                          pointerEvents: "auto !important",
                        },
                      }}
                      className="btn1 py-3 w-100"
                    >
                      {isLoadingDeposit && <Loader color="#423A2A" />}
                      Deposit
                    </button>
                  )
                ) : (
                  <button
                    className="btn1 py-3 w-100"
                    onClick={openConnectModal}
                  >
                    Connect Wallet
                  </button>
                )}
                {address && (
                  <button
                    onClick={() => handlePercentageClick(100)}
                    className="btn3 px-2 py-2"
                  >
                    Max
                  </button>
                )}
              </div>
            </div>
            <div>
              <div
                className={`${style.accord_withdraw_box} d-flex justify-content-between flex-wrap`}
              >
                <p className="mb-0">Withdraw</p>
                <div className="d-flex gap-2 align-items-start p-0 ">
                  <div className="d-flex align-items-center gap-1">
                    <div className={`${style.coin_circle}`}>
                      <img src="/icons/bnb.png" alt="Coin Icon" />
                    </div>
                    <p className="mb-0">
                      {userInfo?.[0]
                        ? parseFloat?.(
                            convertWeiToEther?.(userInfo?.[0]?.toString())
                          ).toFixed(2)
                        : "0.0"}
                      <span className="ps-1" style={{ fontSize: "11.2px" }}>
                        {props.data?.title} Lp
                      </span>
                    </p>
                  </div>
                  <p>
                    {" "}
                    ${" "}
                    {userInfo?.[0]
                      ? parseFloat?.(
                          convertWeiToEther?.(userInfo?.[0]?.toString()) *
                            lpPrice
                        ).toFixed(2)
                      : "0.0"}
                  </p>
                  {/* <div className="d-flex align-items-center gap-1">
                    <div className={`${style.coin_circle}`}>
                      <img src="/icons/bnb.png" alt="Coin Icon" />
                    </div>
                    <p className="mb-0">
                      {userInfo?.[0]
                        ? parseFloat?.(
                          convertWeiToEther?.(userInfo?.[0]?.toString())
                        ).toFixed(5)
                        : "0.0"}
                      <span className="ps-1" style={{ fontSize: "11.2px" }}>WBNB</span>
                    </p>
                  </div> */}
                </div>
              </div>
              {/* <div>
                <input type="number" placeholder='0.0' value={inputWithdrawValue}
                  onChange={handleInputWithdrawChange}
                />
              </div> */}
              <div className="d-flex flex-column justify-content-between">
                <input
                  type="number"
                  className="text-field"
                  placeholder="0.00"
                  value={Number(inputWithdrawValue).toFixed(5)}
                  onChange={handleInputWithdrawChange}
                />
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div className="d-flex align-items-center gap-1">
                    <button
                      className="bg-white"
                      onClick={() => handlePercentageClickWithdraw(10)}
                    >
                      10%
                    </button>
                    <button
                      className="bg-white"
                      onClick={() => handlePercentageClickWithdraw(25)}
                    >
                      25%
                    </button>
                    <button
                      className="bg-white"
                      onClick={() => handlePercentageClickWithdraw(50)}
                    >
                      50%
                    </button>
                    <button
                      className="bg-white"
                      onClick={() => handlePercentageClickWithdraw(75)}
                    >
                      75%
                    </button>
                  </div>
                  <div>
                    {" "}
                    <button
                      className={`btn1 ${style.max_btn}`}
                      onClick={() => handlePercentageClickWithdraw(100)}
                    >
                      Max
                    </button>
                  </div>
                </div>
              </div>
              {/* <button className='btn1 py-3 w-100'> Connect Wallet</button> */}
              <div className="d-flex justify-content-between gap-2">
                <div
                  className={`${style.info_div} position-relative d-flex justify-content-center align-items-center tooltip-parent`}
                >
                  <img src="/icons/info.svg" alt="" />
                  <p className="info-tooltip position-absolute fw-normal">
                    Withdraw LP tokens from the pool. Use percentage buttons for
                    quick selection.
                  </p>
                </div>
                {isConnected && address ? (
                  parseFloat(inputWithdrawValue) >
                  parseFloat(convertWeiToEther(userInfo?.[0]?.toString())) ? (
                    <button className="btn1 py-3 w-100">
                      Insufficient Fund
                    </button>
                  ) : currentTime >= unlockTime ? (
                    // If current time is greater than unlockTime, show the regular withdraw button
                    <>
                      <button
                        disabled={
                          parseFloat(inputWithdrawValue) > 0 &&
                          !isLoadingWithdraw
                            ? false
                            : true
                        }
                        onClick={async () => {
                          try {
                            await withdrawContractWrite();
                            setInputWithdrawValue(0);
                          } catch (error) {
                            console.error(error);
                          }
                        }}
                        className="btn1 py-3"
                      >
                        {isLoadingWithdraw && (
                          <Box sx={{ marginRight: "10px" }}>
                            <Loader color={"#423A2A"} />
                          </Box>
                        )}
                        Withdraw
                      </button>
                    </>
                  ) : (
                    // If current time is less than unlockTime, show the "Withdraw With Penalty" button
                    <>
                      <h8 className="btn3 py-2 px-xxl-3 px-2">
                        {" "}
                        UnlockTime: {formatTimeLeft(timeLeft)}{" "}
                      </h8>
                      <button
                        disabled={
                          parseFloat(userInfo?.[0]) > 0 && !isLoadingWithdraw
                            ? false
                            : true
                        }
                        onClick={async () => {
                          try {
                            await withdrawContractWrite();
                            setInputWithdrawValue(0);
                          } catch (error) {
                            console.error(error);
                          }
                        }}
                        className="btn3 py-2 px-xxl-3 px-2"
                      >
                        {isLoadingWithdraw && (
                          <Box sx={{ marginRight: "10px" }}>
                            <Loader color={"#CCB483"} />
                          </Box>
                        )}
                        Withdraw With Penalty Fee
                        {/* : ( */}
                        {parseFloat?.(inputWithdrawFeeValue)?.toFixed(6)} Lp
                      </button>
                    </>
                  )
                ) : (
                  <button
                    onClick={openConnectModal}
                    className="btn1 py-3 px-3"
                    style={{ width: "78%" }}
                  >
                    Connect Wallet
                  </button>
                )}
              </div>
              <Box width={20} />
            </div>
            <div>
              <div className="d-flex justify-content-between">
                <p>Reward</p>
                {/* <p><span className='me-2'>Balance</span>
                  {pendingReward
                    ? parseFloat?.(
                      convertWeiToEther?.(pendingReward?.toString())
                    ).toFixed(2)
                    : 0}{" "}
                  <span>SHELD</span></p> */}
              </div>
              <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-center gap-3 align-items-center">
                  <div>
                    <div className={`${style.bg_circle_lgold}`}>
                      <img src="/icons/logo.svg" alt="" />
                    </div>
                  </div>
                  <p className="mb-0">
                    {pendingReward
                      ? parseFloat?.(
                          convertWeiToEther?.(pendingReward?.toString())
                        ).toFixed(2)
                      : 0}{" "}
                    <span>SHiELD</span>
                  </p>
                </div>
                {/* <button className='btn1 py-3 px-xl-5 px-3'>Claim</button> */}
                {/* <button
                  disabled={
                    parseFloat?.(pendingReward) > 0 &&
                      !harvestContractWrite?.isLoading &&
                      !harvestWaitForTransaction?.isLoading
                      ? false
                      : true
                  }
                  onClick={async () => {
                    try {
                      await harvestContractWrite?.writeAsync();
                    } catch (error) { }
                  }}
                  className="btn1 py-3 px-xl-5 px-3"
                >
                  {(harvestContractWrite?.isLoading ||
                    harvestWaitForTransaction?.isLoading) && (
                      <Loader color={"black"} />
                    )}
                  Claim
                </button> */}
              </div>
              <div className="d-flex justify-content-between mt-4">
                <a
                  href={`https://pancakeswap.finance/v2/add/${token1Info?.address}/${token0Info?.address}`}
                  target="_blank"
                  style={{
                    fontFamily: "var(--font-pop)",
                    color: "var(--main-color)",
                    fontWeight: "600",
                  }}
                >
                  {" "}
                  Add LP
                </a>
                <a
                  href={`https://pancakeswap.finance/v2/remove/${token1Info?.address}/${token0Info?.address}`}
                  target="_blank"
                  style={{
                    fontFamily: "var(--font-pop)",
                    color: "var(--main-color)",
                    fontWeight: "600",
                  }}
                >
                  Remove LP
                </a>
              </div>
              <div className="mt-2 d-flex justify-content-between gap-3">
                <div
                  className={`${style.info_div} position-relative d-flex justify-content-center align-items-center tooltip-parent`}
                >
                  <img src="/icons/info.svg" alt="" />
                  <p className="info-tooltip position-absolute fw-normal">
                    Click here to add liquidity to the pool and receive LP
                    tokens for staking.
                  </p>
                </div>
                {isConnected && address ? (
                  <button
                    disabled={
                      parseFloat?.(pendingReward) > 0 && !isLoadingHarvest
                        ? false
                        : true
                    }
                    onClick={async () => {
                      try {
                        await harvestContractWrite();
                      } catch (error) {
                        console.log("error", error);
                      }
                    }}
                    sx={{
                      gap: "10px !important",
                      "&.Mui-disabled": {
                        cursor: "not-allowed !important",
                        pointerEvents: "auto !important",
                      },
                    }}
                    className="btn1 py-3 w-100"
                  >
                    {isLoadingHarvest && <Loader color={"black"} />}
                    Claim
                  </button>
                ) : (
                  <button
                    className="btn1 py-3 w-100"
                    onClick={openConnectModal}
                  >
                    Connect Wallet
                  </button>
                )}
                {/* {address && (
                  <button
                    onClick={() =>
                      setMax(
                        lpBalance?.formatted
                          ? parseFloat?.(lpBalance?.formatted).toFixed(9)
                          : "0.00"
                      )
                    }
                    className="btn3 px-2 py-2"
                  >
                    Max
                  </button>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {open ? (
        <ZapModal
          poolIndex={props?.poolIndex}
          token0Info={token0Info}
          token1Info={token1Info}
          lpToken={lpToken}
          handleClose={handleClose}
          index={props.index}
          getApr={getApr()}
          perDay={(
            parseFloat?.(convertWeiToEther?.(rewardPerSecond?.toString())) *
            86400 *
            (props?.poolIndex === 0 ? potionPrice : alienPrice)
          ).toFixed(5)}
        />
      ) : null}
    </>
  );
};
